import type { ScannerIntentSelectors } from "./scanner-intent-bootstrap";

const rootSelector = "#content-scanner-root";

export const claudeSkillSecurityScannerIntentSelectors = {
  scanner: "#scanner",
  input: `${rootSelector} textarea`,
  submit: `${rootSelector} .primary-action`,
  uploadAction: `${rootSelector} .workbench-add-files`,
  fileInput: `${rootSelector} .hidden-file-input`,
  uploadTargets: `${rootSelector} .workbench-add-files, ${rootSelector} .hidden-file-input`,
} satisfies ScannerIntentSelectors;
